import React from 'react';
import {Link} from 'react-router-dom';
import menuService from "@/services/menuService";

const Error404 = () => (
  <div className={'content-wrapper error-page'}>
    <div className={'card card-error'}>
      <div className={'card-header'}>
        <strong>Page not Found</strong>
      </div>
      <div className={'card-body'}>
        <div className={'d-flex align-items-center '}>
          <div>
            <i className={'sprite sprite-error-big'}/>
          </div>
          <div>
            <p className={'text-danger'}>We're sorry!</p>
            <p>The page you requested could be found.</p>
            <p>Please go back to the main with the button below.</p>
          </div>
        </div>
      </div>
      <div className={'card-footer'}>
        <Link className={'btn btn-primary'} to={menuService.paths.spaces()} replace>
          Main
        </Link>
      </div>
    </div>
  </div>
);

export default Error404;
